define(
    'plugins/musicfavourite/ui/button-controller',['../adapter/favouriteService', '../events', '../stats', 'exports'],
    function(Favourites, PubSub, Stats, /* exports */ ButtonController) {

        'use strict';


        /**
         * Favourite button controller
         */
        ButtonController = function(button) {
            var self = this;

            this.id = button.id;
            this.button = button;

            this.added = false; // Default is not-added state

            self.subscribe('busy', function() {
                self.busy = true;
            });

            self.subscribe('finished', function() {
                self.busy = false;
            });

            self.subscribe('added', function() {
                self.added = true;
            });

            self.subscribe('removed', function() {
                self.added = false;
            });

        };


        /**
         * Deprecated - use isAddedAsync with a callback instead.
         *
         * @return {Boolean}
         */
        ButtonController.prototype.isAdded = function() {
            var self = this,
            added = Favourites.isFavourited(self.button.item);

            window.console && window.console.warn('Favourites: isAdded is deprecated');

            if (added !== self.added) {
                self.publish(added ? 'added' : 'removed', self.button);
            }
            return added;
        };


        /**
         * Sends the added state of the button item to a receiver callback.
         *
         * @param {Function} callback
         */
        ButtonController.prototype.isAddedAsync = function(callback) {
            var self = this;

            Favourites.isFavourited(self.button.item, function(added) {
                if (added !== self.added) {
                    self.publish(added ? 'added' : 'removed', self.button);
                }

                callback && callback(added);
            });
        };


        ButtonController.prototype.addFavourite = function(callback) {
            var self = this, item;

            if (self.busy) {
                callback && callback();
                return;
            }

            self.publish('busy.adding', self.button);

            self.isAddedAsync(function(added) {

                if (added) {
                    self.publish('finished', self.button);
                    callback && callback(false);
                    return;
                }

                item = self.button.aux ? [self.button.item, self.button.aux] : self.button.item;

                Favourites.add(item, function(result) {
                    if (result instanceof Error) {
                        if (result === Favourites.errors.SignInCancelled) {
                            self.publish('finished.cancelled.cancelledAdding');
                        } else if (result === Favourites.errors.LimitReached) {
                            self.publish('finished.limited');
                        } else if (result === Favourites.errors.IdUnavailable) {
                            self.publish('finished.failed.failedAdding', true);
                        } else {
                            self.publish('finished.failed.failedAdding', false);
                        }
                    } else {
                        self.publish('finished.added', self.button);
                        self.publish('favAdded', self.button); // workaround for chained events
                    }

                    callback && callback(result);
                });

            });


        };

        ButtonController.prototype.removeFavourite = function(callback) {
            var self = this;

            if (self.busy) {
                callback && callback();
                return;
            }

            self.publish('busy.removing', self.button);

            self.isAddedAsync(function(added) {

                if (!added) {
                    self.publish('finished', self.button);
                    callback && callback(false);
                    return;
                }

                Favourites.remove(self.button.item, function(result) {

                    if (result instanceof Error) {
                        if (result === Favourites.errors.SignInCancelled) {
                            self.publish('finished.cancelled.cancelledRemoving');
                        } else if (result === Favourites.errors.IdUnavailable) {
                            self.publish('finished.failed.failedRemoving', true)
                        } else {
                            self.publish('finished.failed.failedRemoving', false);
                        }
                    } else {
                        self.publish('finished.removed', self.button);
                        self.publish('favRemoved', self.button); // workaround for chained events
                    }

                    callback && callback(result);
                });

            });
        };

        ButtonController.prototype.addFeedback = function(callback) {
            var self = this;

            if (self.busy) {
                callback && callback();
                return;
            }

            self.publish('busy.addingfeedback', self.button);
            this.publish('feedbackMode.dismiss', this.button);

            Favourites.addFeedback(self.button.item, function(result) {
                if (result instanceof Error) {
                    if (result === Favourites.errors.IdUnavailable) {
                        self.publish('finished.failedsendingfeedback', true);
                    } else {
                        self.publish('finished.failedsendingfeedback', false);
                    }
                } else {
                    self.publish('finished.feedbackadded');
                }
                callback && callback();
            });
        };

        ButtonController.prototype.removeFeedback = function(callback) {
            var self = this;

            if (self.busy) {
                callback && callback();
                return;
            }

            self.publish('busy.removingfeedback', self.button);
            this.publish('feedbackMode.undo', this.button);

            Favourites.removeFeedback(self.button.item, function(result) {
                if (result instanceof Error) {
                    if (result === Favourites.errors.IdUnavailable) {
                        self.publish('finished.failedsendingfeedback', true);
                    } else {
                        self.publish('finished.failedsendingfeedback', false);
                    }
                } else {
                    self.publish('finished.feedbackremoved');
                }
                callback && callback();
            });
        };

        /**
         * Toggles the state of the favourite button.
         */
        ButtonController.prototype.toggleFavourite = function() {
            if (this.button.managementMode && this.added) {
                this.publish('managementMode.removeYes', this.button);
                this.removeFavourite();
            }
            else if (this.added) {
                this.publish('toggled.toggledRemove', this.button);
                this.removeFavourite();
            } else {
                this.publish('toggled.toggledAdd', this.button);
                this.addFavourite();
            }
        };

        /**
         * Method to allow for stats tracking when a user changes their mind.
         */
        ButtonController.prototype.keepFavourite = function() {
            if (this.button.managementMode && this.added) {
                this.publish('managementMode.removeNo', this.button);
            }
        };

        ButtonController.prototype.isSignedIn = function() {
            return Favourites.isSignedIn();
        };


        PubSub.context('button.controller', ButtonController);


        // stats workaround for category bug in PubSub-Categories.
        var orig = ButtonController.prototype.publish;
        ButtonController.prototype.publish = function(topic) {
            if (Stats._listeners && Stats._listeners[topic]) {
                Stats.logEvent.apply(Stats, arguments);
            }
            return orig.apply(this, arguments);
        };


        return ButtonController;
    }
);

